<template>
  <main class="teaching subm">
    <sub-menu parent="teaching" title="semesters" :items="teaching.semesters" />
    <section class="news mobile" :class="{ inverse: sideBarOpen === 0 }">
      <div
        class="col left br p"
        @click="toggleSide(0)"
        :class="{ active: sideBarOpen === 0 }"
      >
        <blocks v-if="teaching.text" :content="JSON.parse(teaching.text)" />
      </div>
      <div
        class="col right"
        @click="toggleSide(1)"
        :class="{ active: sideBarOpen === 1 }"
      >
        <print />
        <img-blocks v-if="teaching.text" :content="JSON.parse(teaching.text)" />
      </div>
    </section>
  </main>
</template>

<script>
import SubMenu from "@/components/SubMenu.vue";
import Print from "@/components/Print.vue";
import Blocks from "@/components/Blocks.vue";
import ImgBlocks from "@/components/ImgBlocks.vue";
import { mapState } from "vuex";
export default {
  name: "teaching",
  components: {
    SubMenu,
    Blocks,
    ImgBlocks,
    Print
  },
  metaInfo() {
    return {
      title: "– Teaching"
    };
  },
  computed: mapState(["teaching"]),
  data() {
    return {
      sideBarOpen: 0
    };
  },
  methods: {
    toggleSide(index) {
      this.sideBarOpen = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.years {
  @media only print {
    display: none;
  }
}
</style>
